import React from "react";

import AddIcon from "~/components/Icons/svg/add";
import EditIcon from "~/components/Icons/svg/edit";
import HistoryIcon from "~/components/Icons/svg/history";
import { AccessIProps } from "~/pages/ListOfDocuments/index";

interface ActionsProps {
  record: any;
  getEvent: (item: any, type: string) => void;
  access: AccessIProps;
}

const Actions: React.FC<ActionsProps> = ({ access, record, getEvent }) => {
  return (
    <div style={{ display: "flex", gap: "5px" }}>
      {record.status ? (
        <>
          {access.create && (
            <div
              style={{ cursor: "pointer" }}
              onClick={() => getEvent(record, "create")}
            >
              <AddIcon />
            </div>
          )}
        </>
      ) : (
        <>
          {access.edit && (
            <div
              style={{ cursor: "pointer" }}
              onClick={() => getEvent(record, "edit")}
            >
              <EditIcon />
            </div>
          )}
        </>
      )}
      {!record.status && access.history && (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => getEvent(record, "history")}
        >
          <HistoryIcon />
        </div>
      )}
    </div>
  );
};

export default Actions;
